var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5783 17.4L18.0344 18.9439C17.3497 19.6286 16.4427 20 15.4945 20C15.3454 20 15.1972 19.9906 15.0452 19.9709C11.8253 19.5723 8.27879 17.6439 5.31578 14.681C2.35181 11.7218 0.426331 8.17435 0.0277408 4.95441C-0.109199 3.84482 0.265041 2.75775 1.05762 1.96523L2.60148 0.421365C3.1633 -0.140455 4.0778 -0.140455 4.63777 0.421365L8.03323 3.81682C8.30429 4.08789 8.45624 4.45087 8.45624 4.8345C8.45624 5.21907 8.3071 5.58111 8.03323 5.85218L6.16485 7.72055L12.2784 13.8341L14.1468 11.9657C14.7086 11.4039 15.6212 11.4039 16.1831 11.9657L19.5785 15.3612C20.1403 15.924 20.1403 16.8384 19.5785 17.4003L19.5783 17.4Z",
    fill: "url(#paint0_linear_767_18696)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_767_18696",
    x1: 0,
    y1: 10,
    x2: 19.9999,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5451F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AA04"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.d543c40a75f054d8cb0489c742876195.svg";
export { ForwardRef as ReactComponent };